import { Middleware, MiddlewareAPI, TypedAction } from 'redux';
import matchList from '@gin-betting/match-list';
import core from '@gin-betting/core';

import { matchListRoutes } from 'app-constants';
import { State } from 'types';

const {
    actions: { resetCategory },
} = matchList;
const {
    services: { getHistory },
} = core;

function makeMatchListMiddleware(): Middleware {
    let prevPathname: string;

    return ({ dispatch }: MiddlewareAPI<State>) => {
        const history = getHistory();

        history.listen(({ pathname }) => {
            if (!matchListRoutes.includes(pathname)) return;

            if (prevPathname && pathname !== prevPathname) {
                dispatch(resetCategory({ listType: prevPathname }));
            }

            prevPathname = pathname;
        });

        return next => (action: TypedAction) => next(action);
    };
}

export default makeMatchListMiddleware;
